import React from 'react';
import { getIconWithTooltip } from './helper';
import { Lightbulb, Pending, QuestionMark, ThumbUp } from '@mui/icons-material';
import FieldIcon from '../../b2b-common/FieldIcon';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const Stage = ({ stage, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');

    let icon = null;
    let tooltip = '';

    if (stage === 'IDEA') {
        icon = Lightbulb;
        tooltip = t('Idea');
    } else if (stage === 'PENDING_APPROVAL') {
        icon = Pending;
        tooltip = t('Pending Approval');
    } else if (stage === 'APPROVED') {
        icon = ThumbUp;
        tooltip = t('Approved');
    } else {
        icon = QuestionMark;
        tooltip = t('Not Defined');
    }

    return (
        <FieldIcon label={t('Stage')} icon={getIconWithTooltip(icon, {}, tooltip)} className={className} />
    );
};

export default Stage;